import React, { useState, useRef, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ChevronDown } from 'lucide-react';

interface FAQItemProps {
  question: string;
  answer: string;
  color: 'emerald' | 'blue' | 'purple' | 'orange' | 'green' | 'red';
}

const colorClasses = {
  emerald: 'border-l-emerald-500 hover:bg-emerald-50/50',
  blue: 'border-l-blue-500 hover:bg-blue-50/50',
  purple: 'border-l-purple-500 hover:bg-purple-50/50',
  orange: 'border-l-orange-500 hover:bg-orange-50/50',
  green: 'border-l-green-500 hover:bg-green-50/50',
  red: 'border-l-red-500 hover:bg-red-50/50'
};

export function FAQItem({ question, answer, color }: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      const scrollHeight = contentRef.current.scrollHeight;
      setHeight(isOpen ? scrollHeight : 0);
    }
  }, [isOpen]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Card className={`border-l-4 ${colorClasses[color]} transition-all duration-300 hover:shadow-lg cursor-pointer bg-white rounded-xl`}>
      <CardHeader 
        className="py-5 flex flex-row items-center justify-between space-y-0 px-6"
        onClick={handleToggle}
      >
        <CardTitle className="text-lg flex-1 group-hover:text-gray-700 transition-colors duration-200 font-semibold">
          {question}
        </CardTitle>
        <ChevronDown 
          className={`w-5 h-5 text-gray-500 transition-all duration-300 ease-out ml-4 ${
            isOpen ? 'rotate-180 text-gray-700' : ''
          }`}
        />
      </CardHeader>
      
      <div 
        ref={contentRef}
        style={{ height: `${height}px` }}
        className="overflow-hidden transition-all duration-500 ease-in-out"
      >
        <CardContent className="pt-0 pb-6 px-6">
          <div className="border-t border-gray-100 pt-4">
            <p className="text-gray-700 leading-relaxed">
              {answer.includes('kontakt@kaufpause.at') ? (
                <>
                  Schreib uns einfach eine E-Mail an{' '}
                  <a 
                    href="mailto:kontakt@kaufpause.at" 
                    className="text-emerald-600 hover:underline font-medium transition-colors duration-200"
                    onClick={(e) => e.stopPropagation()}
                  >
                    kontakt@kaufpause.at
                  </a>
                  . Wir antworten normalerweise innerhalb von 24 Stunden und helfen gerne bei allen Fragen rund um KaufPause.
                </>
              ) : (
                answer
              )}
            </p>
          </div>
        </CardContent>
      </div>
    </Card>
  );
} 